import React from 'react';

import { Link } from 'react-router-dom';
import { Container } from 'reactstrap';

type Item = {
  label: string;
  link?: string;
  state?: string;
};

interface Props {
  data: Item[];
}

const Breadcrumb = ({ data }: Props) => {
  return (
    <div>
      <Container>
        <ul className="d-flex py-2 align-items-center tvs-breadcrumb">
          {data.map((item: Item) => (
            <li className="mr-2" key={item.label}>
              {item?.link ? (
                <Link
                  to={{ pathname: item.link, state: { userId: item?.state } }}
                  className="text-small"
                  style={{ textTransform: 'capitalize' }}
                >
                  {item.label}
                </Link>
              ) : (
                <div className="text-small" style={{ fontSize: '14px', color: '#666', fontWeight: 600 }}>
                  {item.label}
                </div>
              )}
            </li>
          ))}
        </ul>
      </Container>
    </div>
  );
};

export default Breadcrumb;
